export default "__VITE_ASSET__Ddo2hh0e__"